import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import { leaveReplayer } from '../game2';

export function dismissLoadingScreen() {
  $('#loading-screen').stop().css('left', '150%');
  try {
    leaveReplayer();
  } catch (_) {}
}

if (typeof window !== 'undefined') {
  window.dismissLoadingScreen = dismissLoadingScreen;
}

function LoadingScreen() {
  const [showCancel, setShowCancel] = useState(false);

  useEffect(() => {
    let timer = null;
    const interval = setInterval(() => {
      const el = document.getElementById('loading-screen');
      if (el) {
        const leftVal = el.style.left;
        const isVisible = leftVal && leftVal !== '100%' && leftVal !== '150%' && leftVal !== '-150%';
        if (isVisible) {
          if (!timer) {
            timer = setTimeout(() => {
              setShowCancel(true);
            }, 2500);
          }
        } else {
          if (timer) {
            clearTimeout(timer);
            timer = null;
          }
          setShowCancel(false);
        }
      }
    }, 400);

    return () => {
      clearInterval(interval);
      if (timer) clearTimeout(timer);
    };
  }, []);

  const handleCancel = () => {
    dismissLoadingScreen();
    setShowCancel(false);
  };

  return (
    <div id='loading-screen' className="loading">
      <h1>Analyzing...</h1>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <span>Please wait, it may take a few seconds.</span>
        {showCancel && (
          <button
            type="button"
            className="loading-cancel-btn"
            onClick={handleCancel}
          >
            Cancel
          </button>
        )}
      </div>
    </div>
  );
}

export default LoadingScreen;